module.exports = __webpack_public_path__ + "img/logo-small.c849abae.png";